.kdx-checkbox {
    > .form-check-input {
        border-radius: 2px;
        height: 20px;
        width: 20px;

        &:checked[type=checkbox] {
            background-image: none;
            background-color: $primary;
            border-color: transparent;
            box-shadow: inset 1px 1px 0px 1px #FFF, 
                        inset -1px -1px 0px 1px #FFF;
        }
    }

    > .form-check-label {
        line-height: $gutter-lg;
    }
}